import React from 'react';
import { CalendarDays, X, Loader2 } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

/**
 * CopyMealToDateDialog — extracted from `pages/Meals.js` (Iter. 405.f).
 *
 * Lets the user copy a historical meal to a specific date (e.g. "Cheat
 * meal 30 mai" → re-log on May 30). Stateless presentational shell —
 * the parent owns the API call (`handleCopyToDate`), date state, and
 * the toggle of which meal is being copied.
 */
export default function CopyMealToDateDialog({
  meal,
  onClose,
  targetDate,
  onTargetDateChange,
  saving,
  onConfirm,
  maxDate,
  t,
}) {
  return (
    <Dialog open={!!meal} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-card border-border max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-heading text-lg uppercase">
            {t ? t('meals_page.copier_le_repas_vers', 'Copier le repas vers...') : 'Copier le repas vers...'}
          </DialogTitle>
          <DialogDescription>
            {meal?.foods_detected?.[0]?.name || ''}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <label className="block text-xs uppercase tracking-wider text-muted-foreground">
            {t ? t('meals_page.date_cible', 'Date cible') : 'Date cible'}
          </label>
          <Input
            type="date"
            value={targetDate}
            onChange={(e) => onTargetDateChange(e.target.value)}
            max={maxDate}
            className="bg-secondary border-border"
            data-testid="copy-meal-date-input"
          />
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={onClose} className="flex-1">
              <X className="w-4 h-4 mr-2" /> {t ? t('meals_page.annuler', 'Annuler') : 'Annuler'}
            </Button>
            <Button
              onClick={onConfirm}
              disabled={saving || !targetDate}
              className="flex-1 bg-primary text-primary-foreground"
              data-testid="copy-meal-confirm-btn"
            >
              {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CalendarDays className="w-4 h-4 mr-2" />}
              {t ? t('meals_page.copier', 'Copier') : 'Copier'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
